import { render, staticRenderFns } from "./systemSettingsAction.vue?vue&type=template&id=4a33865c&scoped=true"
import script from "./systemSettingsAction.vue?vue&type=script&lang=js"
export * from "./systemSettingsAction.vue?vue&type=script&lang=js"
import style0 from "./systemSettingsAction.vue?vue&type=style&index=0&id=4a33865c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33865c",
  null
  
)

export default component.exports